import React from "react";
import { ArrowRight, Scale, Handshake, ShieldCheck } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function DisputeResolutionCenter() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll();
  return <section id="uyuşmazlık-çözüm-merkezi" ref={sectionRef} className="dark bg-gradient-to-br from-[#0B121F] to-[#2F353B] text-foreground relative min-h-[85vh] flex items-center justify-center overflow-hidden py-20">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-black/60 z-10" />
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1568729/img/modern_quiet_meeting_room.png)] bg-cover bg-center bg-no-repeat" />
      </div>

      <div className="container relative z-20 mx-auto px-4 md:px-6">
        <div className={`max-w-4xl mx-auto text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          {}
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#A68966]/20 border border-[#A68966]/40 text-[#A68966] text-sm font-medium mb-6 backdrop-blur-sm">
            <Scale className="w-4 h-4" />
            <span>Uzman Arabuluculuk Hizmeti</span>
          </div>

          {}
          <h1 className="font-serif text-4xl md:text-6xl lg:text-7xl font-bold leading-tight mb-6 text-[#C7D0D9] tracking-tight">
            Arabuluculuk ve <br className="hidden md:block" />
            Alternatif Çözümler
          </h1>

          {}
          <p className="text-lg md:text-xl text-gray-200 mb-10 max-w-2xl mx-auto leading-relaxed font-sans font-normal">
            Hukuki uyuşmazlıklarınızı mahkeme süreçlerine girmeden, hızlı,
            ekonomik ve gizlilik ilkesine tam uygunlukla çözüme kavuşturuyoruz.
            Tarafsız ve güvenilir bir zeminde uzlaşı kültürü.
          </p>

          {}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-16">
            <Link to="https://celikhukuk.net/iletisim/">
              <Button size="lg" className="h-14 px-8 text-base rounded-full w-full sm:w-auto">
                Randevu Oluştur
                <ArrowRight className="ml-2 w-5 h-5" />
              </Button>
            </Link>
            <Link to="https://celikhukuk.net/arabuluculuk/">
              <Button variant="outline" size="lg" className="h-14 px-8 text-base rounded-full bg-white/5 border-white/20 text-white hover:bg-white/10 hover:text-white w-full sm:w-auto backdrop-blur-sm">
                Süreç Hakkında Bilgi
              </Button>
            </Link>
          </div>

          {}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-left">
            {[{
            icon: Handshake,
            title: "Hızlı Çözüm",
            desc: "Yıllar süren davalar yerine, kısa sürede sonuçlanan etkili süreçler."
          }, {
            icon: ShieldCheck,
            title: "Gizlilik Esası",
            desc: "Tüm görüşmeler ve varılan anlaşmalar gizlilik çerçevesinde yürütülür."
          }, {
            icon: Scale,
            title: "Ekonomik Yöntem",
            desc: "Dava masraflarından tasarruf ederek, tarafların menfaatine uygun sonuçlar."
          }].map((item, i) => <div key={i} data-index={i} className={`transition-all duration-700 delay-${i * 200} ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
                <Card className="bg-card/10 border-white/10 backdrop-blur-md hover:bg-card/20 transition-colors duration-300 h-full">
                  <CardContent className="p-6 flex flex-col gap-4">
                    <div className="w-12 h-12 rounded-full bg-[#A68966]/20 flex items-center justify-center text-[#A68966]">
                      <item.icon className="w-6 h-6" />
                    </div>
                    <div>
                      <h3 className="text-xl font-serif font-semibold text-[#C7D0D9] mb-2">
                        {item.title}
                      </h3>
                      <p className="text-gray-300 text-sm leading-relaxed font-sans">
                        {item.desc}
                      </p>
                    </div>
                  </CardContent>
                </Card>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}